<template>
  <div id="app" class="main-page">
    <router-view />
    <header-mobile />
  </div>
</template>

<script>
// imports for all components
import HeaderMobile from './components/HeaderMobile.vue'

export default {
  name: 'about-page',
  components: {
    HeaderMobile
  },
  data() {
    return {
    }
  }
}
</script>
<style>
/* @import url("./assets/css/style.css"); */
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}

</style>
